export default __webpack_public_path__ + "static/media/twitter.3a7f5d48.png";